import React from 'react'; 
import { connect } from 'react-redux'
import {PromiseSequenceRunner} from '../../utils/promiseUtil'
import { LoadingComponent } from '../../utils/ui'
import { AdmsRepository, Linker } from '../../redux';
import { AssetListViewBase } from '../containers';
import { TEAMWORK } from '../../const/C';


/**
 * Спциальный объект, проксирующие выбор записи каталога
 * Основная задача - загрузить необходимые данные и сделать выбор элемента каталога
 */
class AssetListProxy extends React.Component {

  state = {
    loaded: false, 			  //Флаг загрузки, необходимый данных
  }


  static getDerivedStateFromProps(props, state) {
    return null; // Return null to indicate no change to state.
  }

  componentDidMount() {
    this.loadADMS()
  }

  componentWillUnmount(){
    this.props.onUnLoadItems()
  }

  loadADMS() {
    this.setState({loaded: false})
    return PromiseSequenceRunner([ //Promise.all
      //Загрузим описание
      this.props.onLoadItems(),
    ])
    .then ((response) =>{
      this.setState({loaded: true, error: undefined});
    })
    .catch(e => { 
      this.setState({loaded: true, error: e});
    });
  }

  render() {
    console.log(this);
    let { loaded } = this.state;
    if (!loaded) return <LoadingComponent />;
    return (
      <AssetListViewBase  {...this.props} />
    )
  }
}

//Представление информации о Wiki статьях
export default connect(
  null,
  dispatch => ({
    onSelected (IRI, actions, history, item){
      console.log("AssetProxy.js onSelected (IRI, actions, history)", IRI, item);
      const label = (item.dsn)?item.dsn.value: undefined;
      return dispatch(Linker.SELECTED(TEAMWORK.PREDICAT_ASSET, IRI, label));
    },
    onLoadItems(){
      return dispatch(AdmsRepository.PUSH());
    },
    onUnLoadItems(){
      return dispatch(AdmsRepository.POP());
    },
  })
)(AssetListProxy)

